import React from 'react';
import Modal from 'jd-library/Modal';
import withPortal from 'jd-library/withPortal';
import Button from 'jd-library/Button';
import styles from './deletemodal.scss';

const DeleteModal = props => {
    const {
        title,
        subTitle,
        onHidden,
        onDelete,
        btnTxt
    } = props;
    return (
        <Modal
            settings={{
                modalId: 'confirm-delete-modal',
                variant: 'action',
                class: styles['delete-modal']
            }}
            onHidden={onHidden}
        >
            <Modal.CloseIcon />
            <Modal.Header>
                <span className={'title'}>{title}</span>
            </Modal.Header>
            <Modal.Body className={styles['modal-body']}>
                    <div className={'subtitle'}>
                        {subTitle}
                    </div>
                </Modal.Body>
            <Modal.Footer>
                <div className={'button-wrapper'}>
                    <Button size='lg' clickHandler={onDelete} className={`${'delete-btn'}`}>
                        {btnTxt}
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>
    )
};

export default withPortal(DeleteModal,null,'confirm-delete-modal');